import { VariableType } from 'json-to-graphql-query';
export const FilterArgs = { filters: new VariableType('filters') };

export const FilterVariables = { filters: 'FiltersInput' };

export const TypeFilterVariables = { filters: 'TypeFilters' };

export const StatusFilterVariables = { filters: 'StatusFilters' };

export const StructureNodeFilterVariables = { filters: 'StructureNodeFilters' };

export const ModuleFilterVariables = { filters: 'ModuleFilters' };

export const DocumentFilterVariables = { filters: 'DocumentFilters' };

export const AttachmentFilterVariables = { filters: 'AttachmentFilters' };

export const OptionValueFilterVariables = { filters: 'OptionValueFilters' };

export const OptionFilterVariables = { filters: 'OptionFilters' };
